<div class="ti-form-wrapper">
  <div class="ti-progress-detectors">
    <h1>{{ (isNew ? 'lexicon.lexeme-family-connection-creation' : 'lexicon.lexeme-family-connection-edit') |
      translate}}</h1>
    <mat-progress-bar *ngIf="showSpinner" color="accent" mode="indeterminate"></mat-progress-bar>
    <app-error-message [errorMessageSource]="errorMessageSource"></app-error-message>
  </div>
  <form class="ti-form" *ngIf="form" [formGroup]="form">
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'COMMON.lexeme' | translate}}</p>
      <p>{{lexemeFamilyConnection.lemma}}</p>
    </div>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'COMMON.family-id' | translate}}</p>
      <p [ngClass]="(lexemeFamilyConnection.familyId === 0) ? 'ti-red-text': ''">
        {{lexemeFamilyConnection.familyId}} </p>
      <div>
        <button
          mat-mini-fab
          color="primary"
          [disabled]="!doesUserHaveAccessToEdit"
          appOpenFamilySelectionDialog
          [chooseOnlyOneFamily]="true"
          (click)="clearTheErrorMessage()"
          style="margin-left: 10px"
          (selectedDataEvent)="saveUpdatedFamily($event)">
          <mat-icon aria-hidden="true">search</mat-icon>
        </button>
      </div>
    </div>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'COMMON.description' | translate}}</p>
      <p>{{lexemeFamilyConnection.familyDescription}}</p>
    </div>
    <div class="ti-form__one-line-fields">
      <mat-checkbox
        matInput
        formControlName="discouraged" name="discouraged"
        (click)="clearTheErrorMessage()"
        maxlength="2"
        minlength="1"
        appDisableControl
        [disableControl]="!doesUserHaveAccessToEdit"
        [(ngModel)]="lexemeFamilyConnection.discouraged">
        <span class="ti-form__label">   {{'lexicon.discouraged' | translate}}</span>
      </mat-checkbox>
    </div>
    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'COMMON.frequency' | translate}}</p>
      <mat-form-field color="accent">
        <input
          matInput
          formControlName="frequency"
          name="frequency"
          appDisableControl
          [disableControl]="!doesUserHaveAccessToEdit"
          [(ngModel)]="lexemeFamilyConnection.frequency"
          (keypress)="clearTheErrorMessage()">
      </mat-form-field>
    </div>
    
    <div class="ti-form__bordered-part">
      <span class="ti-form-bordered-part__label">{{'COMMON.features' | translate}}</span>
    
      <div class="ti-form__bordered-part">
        <div class="ti-form__one-line-fields ti-form-bordered-part__label">
          <span class="ti-form-bordered-part__label">{{'COMMON.grammar' | translate}}</span>
        </div>
        <div class="ti-form-bordered-part__content" style="display: flex">
          <app-universal-features *ngIf="relevantGrammarFeatureList" [featureValues]="lexemeFamilyConnection.grammar"
            [doesTheWholeFeatureListRelevant]="dontFilterGrammar" [relevantFeatureList]="relevantGrammarFeatureList"
            [isOnlyOneFeature]="false" (featuresUpdatedValueEvent)="disableTagTrace($event)"
            [disableSelect]="!doesUserHaveAccessToEdit">
          </app-universal-features>
        </div>
      </div>
      <div class="ti-form__bordered-part">
        <div class="ti-form__one-line-fields ti-form-bordered-part__label">
          <span class="ti-form-bordered-part__label">{{'lexicon.style' | translate}}</span>
        </div>
        <div class="ti-form-bordered-part__content" style="display: flex">
          <app-universal-features *ngIf="relevantStyleFeatureList" [featureValues]="lexemeFamilyConnection.style"
            [doesTheWholeFeatureListRelevant]="true" [relevantFeatureList]="relevantStyleFeatureList"
            [isOnlyOneFeature]="false" (featuresUpdatedValueEvent)="disableTagTrace($event)" [disableSelect]="!doesUserHaveAccessToEdit">
          </app-universal-features>
        </div>
      </div>
      <div class="ti-form__bordered-part">
        <div class="ti-form__one-line-fields ti-form-bordered-part__label">
          <span class="ti-form-bordered-part__label">{{'COMMON.semantic' | translate}}</span>
        </div>
        <div class="ti-form-bordered-part__content" style="display: flex">
          <app-universal-features *ngIf="relevantStyleFeatureList" [featureValues]="lexemeFamilyConnection.semantics"
            [doesTheWholeFeatureListRelevant]="true" [relevantFeatureList]="semanticFeatureList" [isOnlyOneFeature]="false"
            (featuresUpdatedValueEvent)="disableTagTrace($event)" [disableSelect]="!doesUserHaveAccessToEdit">
          </app-universal-features>
        </div>
      </div>
    </div>

    <div class="ti-form__one-line-fields advanced-criteria__wrapper">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'COMMON.advanced-criteria' | translate}}</p>
        <div *ngIf="lexemeFamilyConnection.advancedCriteriaDescription" class="ti-advanced-criteria__description">{{lexemeFamilyConnection.advancedCriteriaDescription}}</div>
        <div class="ti-advanced-criteria__buttons">
          <button
            *ngIf="doesUserHaveAccessToEdit"
            mat-mini-fab
            color="primary"
            (click)="clearTheErrorMessage()"
            appAdvancedCriteriaButton
            [forWords]="true"
            [dialogTitle]="'lexemes'"
            (selectedDataEvent)="reactOnSelectedAdvancedCriteria($event)"
            style="margin-left: 10px"
          >
            <mat-icon aria-hidden="true">search</mat-icon>
          </button>
          <button
            mat-mini-fab
            color="primary"
            (click)="clearTheErrorMessage()"
            style="margin-left: 10px"
            [disabled]="!doesUserHaveAccessToEdit || !lexemeFamilyConnection.advancedCriteriaId"
            appAdvancedCriteriaOpenEditDialog
            [forWords]="true"
            (updateDataEvent)="reactOnUpdateAdvancedCriteria()"
            [isEdit]="true"
            [currentId]="lexemeFamilyConnection.advancedCriteriaId"
          >
            <mat-icon aria-hidden="true">edit</mat-icon>
          </button>
          <button
            mat-mini-fab
            color="primary"
            (click)="clearTheErrorMessage();clearAdvancedCriteria();"
            style="margin-left: 10px"
            [disabled]="!doesUserHaveAccessToEdit || !lexemeFamilyConnection.advancedCriteriaDescription"
          >
            <mat-icon aria-hidden="true">clear</mat-icon>
          </button>
        </div>
    </div>

    <div class="ti-form__one-line-fields" *ngIf="lexemeFamilyConnection.lexemeId">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'COMMON.lexeme-id' | translate}}</p>
      <p>
        {{lexemeFamilyConnection.lexemeId}}</p>
    </div>

    <div class="ti-form__one-line-fields">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{ 'lexicon.legacy-map-id' | translate}}</p>
      <p>
        {{lexemeFamilyConnection.legacyMapId}}</p>
    </div>
    <div class="ti-form__one-line-fields" *ngIf="!isNew || (isNew && isAdmin())">
      <p class="ti-form__label ti-form__form-attribute-value-field">{{'commonsense-cues.approval-status' | translate}}</p>
      <mat-form-field class="ti-clause__select">
        <mat-select
          role="listbox"
          [(value)]="lexemeFamilyConnection.unverified"
          [disabled]="!doesUserHaveAccessToEdit"
        >
          <mat-option [value]="0">{{'lexicon.approved' | translate}}</mat-option>
          <mat-option [value]="1">{{'lexicon.failed-auto-check' | translate}}</mat-option>
          <mat-option [value]="2">{{'lexicon.auto-generated' | translate}}</mat-option>
          <mat-option [value]="3">{{'lexicon.human-factor' | translate}}</mat-option>
          <mat-option [value]="4">{{'lexicon.auto-grammar' | translate}}</mat-option>
          <mat-option [value]="5">{{'lexicon.auto-style' | translate}}</mat-option>
          <mat-option [value]="6">{{'lexicon.health-check' | translate}}</mat-option>
        </mat-select>
        <!-- <mat-select
          [(value)]="lexemeFamilyConnection.unverified"
        >
          <mat-option [value]="true">{{'commonsense-cues.pending-approval' | translate }}</mat-option>
          <mat-option [value]="false">{{'commonsense-cues.approved' | translate }}</mat-option>
        </mat-select> -->

      </mat-form-field>
    </div>

    <div class="ti-form__button-panel">
      <button
        mat-raised-button
        (click)="clearTheErrorMessage();cancel()">{{'COMMON.cancel' | translate}}
      </button>
      <button
        [disabled]="!doesUserHaveAccessToEdit"
        mat-raised-button
        color="accent"
        (click)="clearTheErrorMessage();save()">{{'COMMON.save' | translate}}
      </button>
    </div>
  </form>
</div>
